<!-- RESOURCES RECORD View MAIN Column MAINBODY Record Table -->
<template>
    <table class="table_resources">
            <thead>
                <tr>
                    <th>
                        <h4 :class="['datatable_cell_ch', sortNamech ? 'active' : '']" @click="sortbyNamech">提名</h4>
                        <h4 :class="['datatable_cell_eng', sortNameeng ? 'active' : '']" @click="sortbyNameeng">Title</h4>
                    </th>
                    <th :class="['sorttogether', sortAuthor ? 'active' : '']" @click="sortbyAuthor">
                        <h4 class="datatable_cell_ch">作者</h4>
                        <h4 class="datatable_cell_eng">Author</h4>
                    </th>
                    <th :class="['sorttogether', sortDate ? 'active' : '']" @click="sortbyDate">
                        <h4 class="datatable_cell_ch">日期</h4>
                        <h4 class="datatable_cell_eng">Date</h4>
                    </th>
                    <th :class="['sorttogether', sortType ? 'active' : '']" @click="sortbyType">
                        <h4 class="datatable_cell_ch">類別</h4>
                        <h4 class="datatable_cell_eng">Type</h4>
                    </th>
                    <th :class="['sorttogether', sortRecordid ? 'active' : '']" @click="sortbyRecordid">
                        <h4 class="datatable_cell_ch">識別號</h4>
                        <h4 class="datatable_cell_eng">ID</h4>
                    </th>
                </tr>
            </thead>
            <tbody>
                <!-- : is for v-bind    @ is for v-on -->
                <!-- https://forum.vuejs.org/t/add-class-on-clicked-list-element-remove-class-from-not-clicked-elements/21771 -->
                <tr v-for="item in recordset" :key="item.id" @click="selectRecord(item.id, item.recordid, 'resource')" :class="((item.recordid === initiallyselectedrecordid) && !recordwasclicked) || (item.id == recordkeyidselected) ? 'selected' : ''">
                    <td>
                        <p class="datatable_cell_ch">{{ item.namech }}</p>
                        <p class="datatable_cell_eng">{{ item.nameeng }}</p>
                    </td>
                    <td>
                        <p class="datatable_cell_ch">{{ item.author }}</p>
                    </td>
                    <td>
                        <p class="datatable_cell_cheng">{{ item.date }}</p>
                    </td>
                    <td>
                        <p class="datatable_cell_cheng">{{ item.type }}</p>
                    </td>
                    <td>
                        <p class="datatable_cell_id">{{ item.recordid }}</p>
                    </td>
                </tr>
            </tbody>
        </table>
</template>

<script>
import store from '@/store'
import router from '@/router'

export default {
    name: 'RecordtableResources',
    props: {
        recordsettoshow: Array,
        initiallyselectedrecordid: String
    },
    data(){
        return {
            recordkeyidselected: undefined,
            recordwasclicked: false,
            recordset: this.recordsettoshow,
            sortNamech: false,
            sortNameeng: false,
            sortAuthor: false,
            sortDate: false,
            sortType: false,
            sortRecordid: false,
        }
    },
    methods: {
        selectRecord(keyid, selectedrecordid, selectedrecordtype) { 
            this.recordwasclicked = true

            this.recordkeyidselected = keyid 
            //Set currentRecordType
            store.state.currentRecordType = selectedrecordtype
            //Set currentRecordID            
            store.state.currentResourceRecordID = selectedrecordid
            store.commit('updateMenuOpened', true)
            //Push to new URL
            router.push(`/records/` + selectedrecordtype + `/${store.state.currentResourceRecordID}`, () => {}) 
            //Last part catches the error https://github.com/vuejs/vue-router/issues/2881#issuecomment-520554378 when same link pressed twice
            //Doesn't happen when using router-link, but need to use this for the router.push
        },
        sortbyNamech(){
            this.sortNamech = true
            this.sortNameeng = false
            this.sortAuthor = false
            this.sortDate = false
            this.sortType = false
            this.sortRecordid = false
            this.recordset = store.getters.sortResourcesAscnamech
        },
        sortbyNameeng(){
            this.sortNamech = false
            this.sortNameeng = true
            this.sortAuthor = false
            this.sortDate = false
            this.sortType = false
            this.sortRecordid = false
            this.recordset = store.getters.sortResourcesAscnameeng
        },
        sortbyAuthor(){
            this.sortNamech = false
            this.sortNameeng = false
            this.sortAuthor = true
            this.sortDate = false
            this.sortType = false
            this.sortRecordid = false
            this.recordset = store.getters.sortResourcesAscauthor
        },
        sortbyDate(){
            this.sortNamech = false
            this.sortNameeng = false
            this.sortAuthor = false
            this.sortDate = true
            this.sortType = false
            this.sortRecordid = false
            this.recordset = store.getters.sortResourcesAscdate
        },
        sortbyType(){
            this.sortNamech = false
            this.sortNameeng = false
            this.sortAuthor = false
            this.sortDate = false
            this.sortType = true
            this.sortRecordid = false
            this.recordset = store.getters.sortResourcesAsctype
        },
        sortbyRecordid(){
            this.sortNamech = false
            this.sortNameeng = false
            this.sortAuthor = false
            this.sortDate = false
            this.sortType = false
            this.sortRecordid = true
            this.recordset = store.getters.sortResourcesAscrecordid
        }

    }
}
</script>
